import { useState } from "react";
import { useOptionalPlotSelection } from "../context/PlotSelectionContext";

export const usePlotOutline = (): {
  isOutlined: (id: string) => boolean;
  toggleOutline: (id: string) => void;
} => {
  const selection = useOptionalPlotSelection();
  const [localOutlinedIds, setLocalOutlinedIds] = useState<string[]>([]);

  return {
    isOutlined:
      selection?.isOutlined ?? ((id) => localOutlinedIds.includes(id)),
    toggleOutline:
      selection?.toggleOutline ??
      ((id) => {
        setLocalOutlinedIds((previous) =>
          previous.includes(id)
            ? previous.filter((item) => item !== id)
            : [...previous, id]
        );
      }),
  };
};
